var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBigRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.74984V3.98317C13.3333 2.90974 13.3333 2.37302 13.1244 1.96302C12.9407 1.60238 12.6475 1.30917 12.2868 1.12541C11.8768 0.916504 11.3401 0.916504 10.2667 0.916504H8.73333C7.6599 0.916504 7.12318 0.916504 6.71318 1.12541C6.35254 1.30917 6.05933 1.60238 5.87557 1.96302C5.66667 2.37302 5.66667 2.90974 5.66667 3.98317V4.74984M7.58333 10.0207V14.8123M11.4167 10.0207V14.8123M0.875 4.74984H18.125M16.2083 4.74984V15.4832C16.2083 17.0933 16.2083 17.8984 15.895 18.5134C15.6193 19.0544 15.1795 19.4942 14.6386 19.7698C14.0236 20.0832 13.2185 20.0832 11.6083 20.0832H7.39167C5.78152 20.0832 4.97644 20.0832 4.36144 19.7698C3.82048 19.4942 3.38066 19.0544 3.10502 18.5134C2.79167 17.8984 2.79167 17.0933 2.79167 15.4832V4.74984",
    stroke: "#C9303D",
    strokeWidth: 0.984954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBigRed);
export default __webpack_public_path__ + "static/media/delete_big_red.2266323e14e2c5511ddb9c7be156717a.svg";
export { ForwardRef as ReactComponent };